import React from "react";
type ToolProps = React.PropsWithChildren<{}>;
function Tool(props: ToolProps) {
	return <div className="h-full">{props.children}</div>;
}

export default Tool;
